// extracted by mini-css-extract-plugin
export default {"headerContainer":"PalletsPickUpsPage_headerContainer__ZnFYU","banner":"PalletsPickUpsPage_banner__jm6QH"};